define((require) => {
    "use strict";

    const ImprovedView                          = require("editor/zbone/ImprovedView");
    const LoggedIn                              = require("shared/security/LoggedIn");
    const Permissions                           = require("shared/security/Permissions");
    const QuickViewAddExperienceViewTemplate    = require("ui/experienceOverview/QuickViewAddExperienceView.tpl");
    const TemplateCollection                    = require("data/TemplateCollection");
    const TemplateSorting                       = require("ui/dashboard/TemplateSorting");

    let TemplateContentCollectionViewProxy = (options) => {
        // Due to a circular dependency somewhere we need to use a dynamic require.
        const TemplateContentCollectionView = require("ui/dashboard/TemplateContentCollectionView");
        return new TemplateContentCollectionView(options);
    };
    /**
     * The <tt>QuickViewAddExperienceView</tt> is used to display add experience details inside a <tt>LightBox</tt>.
     *
     * @class QuickViewAddExperienceView
     */
    const QuickViewAddExperienceView = ImprovedView.extend({

        template: QuickViewAddExperienceViewTemplate,

        regions: {
            templates: ".templates"
        },

        onShow: function() {
            const collection = new TemplateCollection();

            return collection.query(TemplateSorting.current().query)
                .then(() => {
                    return {
                        collection,
                        showCreateDisclaimer: true,
                        principal: LoggedIn.principal(),
                        spectatorMode: Permissions.Privileges.CREATE.cannot(),
                        closeQuickView: () => this.close(),
                        scrollTarget: this.$el
                    };
                }).then((options) => {
                    const view = TemplateContentCollectionViewProxy(options);
                    this.templates.show(view);
                });
        }
    });

    return QuickViewAddExperienceView;
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/QuickViewAddExperienceView.js